import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialsModule } from './materials/materials.module';
import { CoreModule } from './core/core.module';
import { AuthModule } from './auth/auth.module';
import { SharedModule } from './shared/shared.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { DashboardModule } from './dashboard/dashboard.module';
import { GeneralInterceptor } from './shared/general.interceptor';
import { SuperAdminModule } from './super-admin/super-admin.module';
import { ManufacturerModule } from './manufacturer/manufacturer.module';
import { ProductModule } from './product/product.module';
import { DistributorModule } from './distributor/distributor.module';
import { environment } from '../environments/environment';
import {NgxImageCompressService} from 'ngx-image-compress';
import { BaseChartDirective } from 'ng2-charts';
import { StatisticsModule } from './statistics/statistics.module';
import { OnlineStatusModule } from 'ngx-online-status';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { ToastrModule } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { Chart, BarController, BarElement, CategoryScale, LinearScale, Title, Tooltip, Legend, LineController, LineElement, PointElement, ArcElement, PieController } from 'chart.js';
import { CookieConsentComponent } from './cookie-consent/cookie-consent.component';
import { EllipsisTooltipDirective } from './shared/directives/ellipsis-tooltip.directive';

// Register needed chart types and elements
Chart.register(
  BarController, BarElement, CategoryScale, LinearScale,
  Title, Tooltip, Legend,
  LineController, LineElement, PointElement,
  ArcElement, PieController
);

@NgModule({
  declarations: [
    AppComponent,
    CookieConsentComponent
  ],
  imports: [
    BrowserModule,
    AuthModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialsModule,
    CoreModule,
    SharedModule,
    DashboardModule,
    SuperAdminModule,
    ManufacturerModule,
    DistributorModule,
    ProductModule,
    BaseChartDirective,
    StatisticsModule,
    OnlineStatusModule,
    HttpClientModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireMessagingModule,
    EllipsisTooltipDirective,

    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
    }),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: GeneralInterceptor, multi: true },
    NgxImageCompressService,
    CookieService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
